import { Editor } from 'grapesjs';
import { faHeading } from '@fortawesome/pro-solid-svg-icons/faHeading';
import { EditorComponentDefinition } from './types';
import {
  GrapesjsComponent,
  renderLocalizedComponent,
} from '../../helpers/render-localized-component';
import { PARENT_TYPE, translateAttributes } from '../../services/copy-paste/copy-paste-utils';
import { Toolbar } from '../utils';
import { achievementsHistoryV2ComponentDefinition } from './transaction-history-v2/transaction-history-v2-grapes-component';
import { leaderboardComponentDefinition } from './leaderboard/leaderboard-grapes-component';
import { qrCodeComponentDefinition } from './qrcode/qrcode-grapes-component';
import { referralCodeComponentDefinition } from './referral/referral-code-grapes-component';
import { rewardsComponentDefinition } from './rewards/rewards-grapes-component';
import { rewardsWonComponentDefinition } from './rewards-won/rewards-won-grapes-component';
import { updateI18nAttributes } from './i18n';

const CLASSNAME = 'qlfeditor-title';

// if title gets added to other composed widgets, add its cases here
const translations = {
  [leaderboardComponentDefinition.id]: 'editor.leaderboard.title',
  [rewardsComponentDefinition.id]: 'editor.rewards.title',
  [rewardsWonComponentDefinition.id]: 'editor.rewards-won.title',
  [achievementsHistoryV2ComponentDefinition.id]: 'editor.achievements-history.title',
  [referralCodeComponentDefinition.id]: 'editor.referral-code.title',
  [qrCodeComponentDefinition.id]: 'editor.qrcode.title',
};

// @deprecated
export const titleComponentDefinition: EditorComponentDefinition = {
  id: 'title',
  icon: faHeading,
  getLabel: ({ t }) => t('editor.component.title'),
  component: TitleComponent,
  copyPasteHelper: (element, context) => {
    const translationKey = translations[element[PARENT_TYPE]];

    if (!translationKey) {
      return translateAttributes(element, context.destinationLocales);
    }

    return translateAttributes(element, context.destinationLocales, {
      property: 'content',
      translationKey,
    });
  },
};

// @deprecated
export function TitleComponent(editor: Editor) {
  const i18n = editor.I18n;

  editor.DomComponents.addType(titleComponentDefinition.id, {
    isComponent(el: HTMLElement) {
      return el.tagName === 'H1' && el.classList.contains(CLASSNAME);
    },
    extend: 'text',
    model: {
      defaults: {
        tagName: 'h1',
        attributes: {
          class: CLASSNAME,
        },
        content: '',
        name: 'title',
        traits: [],
        removable: true,
      },
      initToolbar: Toolbar,
    },
    view: {
      init({ model }: { model: any }) {
        this.listenTo(model, 'rte:disable', () => {
          this.getContent().then((content: string) => {
            updateI18nAttributes.call(this, i18n.getLocale(), { content });
          });
        });
      },
      onRender() {
        renderLocalizedComponent(this as GrapesjsComponent, i18n);
      },
    },
  });
}
